import React from "react";
import "./enquiry.css";
// import phoneIcon from "../../assets/phone.jpg"; // Ensure this is a phone icon image
import whatsappIcon from "../../assets/whatapp.jpg"; // Ensure this is a WhatsApp icon image

const EnquireNowButton = () => {
  return (
    <div className="enquire-now-container">
      <div className="icons-container">
        {/* Phone dialer link */}
        <a href="tel:+916383786782">
          {/* <img src={phoneIcon} alt="Phone" className="icon" /> */}
        </a>

        {/* WhatsApp chat link */}
        <a
          href="https://wa.me/6383786782?text=Hi%2C%20I%20am%20interested%20to%20buy%20a%20product."
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={whatsappIcon} alt="WhatsApp" className="icon" />
        </a>
      </div>
    </div>
  );
};

export default EnquireNowButton;
